import { forwardRef } from 'react'

import { IconProps } from '../../../types/types'

export const ToolSvg = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
	const { size = 24, ...rest } = props

	return (
		<svg
			ref={ref}
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...rest}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.27258 7.93121L6.77827 8.42551L2 5.29492L5.29536 1.99956L8.42595 6.77783L7.93165 7.27214L13.1241 12.4646C14.0288 11.8652 15.2598 11.964 16.057 12.7611L19.3523 16.0565C20.2623 16.9665 20.2623 18.4419 19.3523 19.3519C18.4423 20.2619 16.967 20.2619 16.057 19.3519L12.7616 16.0565C11.9645 15.2594 11.8656 14.0284 12.465 13.1237L7.27258 7.93121Z"
				fill="url(#paint0_linear_13382_131596)"
			/>
			<path
				d="M20.2429 5.6929C20.2362 5.68616 18.8714 7.03618 16.1553 9.7497L14.2496 7.8426L18.3102 3.77906C16.1733 2.49194 13.4281 2.82214 11.648 4.60345C10.9676 5.28398 10.478 6.13158 10.2282 7.06125C9.97839 7.99091 10.1899 9.24117 10.4376 10.1714L10.478 10.3219L4.07579 16.725C3.93662 16.8643 4.00642 17.0288 4.14559 17.168L6.82648 19.8493C6.96565 19.9885 7.13771 20.0658 7.27688 19.9265L13.6791 13.5234L13.8295 13.5639C15.7083 14.0648 17.9892 13.7571 19.3899 12.3554C21.1722 10.5741 21.5022 7.82688 20.2429 5.6929Z"
				fill="#4A4A4A"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_13382_131596"
					x1="18.4124"
					y1="22.0368"
					x2="0.962755"
					y2="4.58721"
					gradientUnits="userSpaceOnUse">
					<stop stopColor="#5C90FC" />
					<stop offset="1" stopColor="#B7D2FF" />
				</linearGradient>
			</defs>
		</svg>
	)
})
